import { ProfileGQL } from '@/graphql/queries'

import hasActiveContracts from '@/mixins/hasActiveContracts'
import { setMerchantSlug } from '@/mixins/pinToken'

export default {
  mixins: [hasActiveContracts, setMerchantSlug],

  apollo: {
    profileLoc: {
      query: ProfileGQL,
      skip () {
        return !this.hasActiveContracts
      },
      update: data => data.merchant.profile
    }
  },

  computed: {
    profile () {
      if (!this.profileLoc) {
        return {}
      }

      return this.profileLoc
    }
  },

  watch: {
    async 'profile.slug' (val) {
      await this.setMerchantSlug(val)
    }
  }
}
